import { connect } from 'react-redux';
import { createContact, updateContact } from 'shared/store/actions/contacts.actions';
import { ContactDetailsFormComponent } from './contact-details-form.component';
import { isCollaborator } from 'shared/store/selectors/auth.selector';

const mapStateToProps = ({ lang, auth }) => {
  return {
    lang: lang.CONTACT_SCREEN,
    canEdit: isCollaborator({
      auth,
    }),
  };
};

export const ContactDetailsForm = connect(mapStateToProps, {
  createContact,
  updateContact,
})(ContactDetailsFormComponent);
